// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.min.js";



$('.about-us-slider').slick({
  speed: 2000,
  adaptiveHeight: true,
  prevArrow : '<div class="arrow left position-absolute"></div>',
  nextArrow: '<div class="arrow right position-absolute"></div>',
});
